import script from "./StepSelfie.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSelfie.vue?vue&type=script&setup=true&lang=js"

import "./StepSelfie.vue?vue&type=style&index=0&id=6ddcf83a&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ddcf83a"]])

export default __exports__